import {
    AfterViewInit,
    Component,
    ElementRef,
    ViewChild,
    ViewEncapsulation,
    OnInit,
    HostListener
} from '@angular/core';
import { CmsComponent } from '@signature-it/ngx-generic/components/cms';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import {ShareDataService} from '@signature-it/ngx-generic/services';

declare let $: any;

@Component({
    selector: 'main-header',
    templateUrl: './main-header.html',
    styleUrls: ['./main-header.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MainHeaderComponentGeneric implements AfterViewInit, OnInit {

    cmsTitle: string;

    @ViewChild('cmsComp') cmsComp: CmsComponent;
    @ViewChild('containerRef') containerRef: ElementRef;

    isDam: boolean = GenericConfig.isDam ? true : false;
    isRestricted = false;

    windowWidth;

    constructor(protected elRef: ElementRef,
                public shareSvc: ShareDataService) {}

    ngAfterViewInit(): void {
    }


    ngOnInit(): void {
        this._getHeaderCmsName();
        this.windowWidth = window.innerWidth;
    }

    _getHeaderCmsName() {
        this.shareSvc.isRestrictedLogin$.subscribe(isRestricted => {
            const name = GenericConfig.headerCmsName ?
                GenericConfig.headerCmsName :
                (GenericConfig.isDam) ? 'ngx-header-media' : 'ngx-header';
            if(isRestricted !== null) {
                this.cmsTitle = isRestricted ? 'restricted-login-header-cms' : name;
            }
        });
    }


    onResize(event) {

        const widthAfter = event.target.innerWidth;
        this.windowWidth = widthAfter;
    }


    @HostListener('window:resize', ['$event'])
    onResizeEvent(event) {
        this.onResize(event);
    }

}
